module.exports = __webpack_public_path__ + "static/media/16UNODC27.6ee68784.jpg";